import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Badge, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip as ChartTooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import contadorDocumentos from "../functions/contadorDocumentos";
import { getFirestore, collection, query, where } from "firebase/firestore";
// getDocs instrumentado: informa cuántas lecturas hace esta pantalla para
// poder atribuir el consumo de Firestore a cada usuario (visible solo para superAdmin).
import { getDocs } from "../functions/getDocsInstrumentado";
import { establecerOrigenConsumo } from "../functions/consumoLecturas";
import firebaseApp from "../firebase/credenciales";
import { Link } from "react-router-dom";
import { 
  FaUserCheck, FaUserClock, FaUsers, FaChartBar, FaFileAlt, FaChartPie, 
  FaRegChartBar, FaWallet, FaCalculator, FaRobot, FaBrain, FaRocket,
  FaBus, FaFileInvoice, FaBuilding, FaUserTie, FaClock, FaArrowRight, 
  FaShieldAlt, FaMagic, FaFolderOpen, FaUserPlus, FaCalendarAlt
} from "react-icons/fa";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { BsFillPersonCheckFill, BsGraphUp } from "react-icons/bs";
import { HiOutlineDocumentReport, HiOutlineReceiptTax } from "react-icons/hi";
import { TbReportAnalytics, TbReportMoney } from "react-icons/tb";
import { obtenerIndicadoresAsistencia } from "../functions/obtenerIndicadoresAsistencia";
import { obtenerIndicadoresPlanilla } from "../functions/obtenerIndicadoresPlanilla";
import { obtenerReporteFinanciero } from "../services/contabilidad/reportesService";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, ChartTooltip, Legend, ArcElement);

const MESES = [
  "ENE", "FEB", "MAR", "ABR", "MAY", "JUN",
  "JUL", "AGO", "SET", "OCT", "NOV", "DIC"
];

const MESES_VALOR = [
  "01", "02", "03", "04", "05", "06",
  "07", "08", "09", "10", "11", "12"
];

const COLORS = [
  "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0",
  "#9966FF", "#FF9F40", "#00A36C", "#C70039",
  "#FFC300", "#2E86C1", "#A569BD", "#229954"
];

const TIPOS_DOCUMENTO = [
  "Todos",
  "Boletas de pago",
  "CTS",
  "Gratificaciones",
  "Utilidades",
  "Contratos",
  "Memorandums",
  "Vacaciones",
  "PoliticasLaborales",
];

const db = getFirestore(firebaseApp);

const Home = ({ usuario }) => {
  // CONTROL DE CARGA BAJO DEMANDA (Carga rápida inicial)
  const [dashboardCargado, setDashboardCargado] = useState(false);

  // USUARIOS (solo momento actual)
  const [loadingUsuarios, setLoadingUsuarios] = useState(true);
  const [usuariosTotales, setUsuariosTotales] = useState(0);
  const [usuariosActivos, setUsuariosActivos] = useState(0);
  const [usuariosFirmas, setUsuariosFirmas] = useState(0);
  const [errorUsuarios, setErrorUsuarios] = useState(null);

  // GESTIÓN DOCUMENTAL
  const [loadingDocumentos, setLoadingDocumentos] = useState(true);
  const [error, setError] = useState(null);

  const [dataDocumentos, setDataDocumentos] = useState({
    enero: 0, febrero: 0, marzo: 0, abril: 0, mayo: 0, junio: 0,
    julio: 0, agosto: 0, setiembre: 0, octubre: 0, noviembre: 0, diciembre: 0
  });
  const [dataVistos, setDataVistos] = useState({
    enero: 0, febrero: 0, marzo: 0, abril: 0, mayo: 0, junio: 0,
    julio: 0, agosto: 0, setiembre: 0, octubre: 0, noviembre: 0, diciembre: 0
  });
  const [dataFirmados, setDataFirmados] = useState({
    enero: 0, febrero: 0, marzo: 0, abril: 0, mayo: 0, junio: 0,
    julio: 0, agosto: 0, setiembre: 0, octubre: 0, noviembre: 0, diciembre: 0
  });
  const [year, setYear] = useState(new Date().getFullYear());
  const [viewType, setViewType] = useState('mensual');
  const [tipoDocumento, setTipoDocumento] = useState('Todos');
  const [dataSemanal, setDataSemanal] = useState({});
  const [dataSemanalRaw, setDataSemanalRaw] = useState({});
  const [periodo, setPeriodo] = useState(MESES_VALOR[new Date().getMonth()]); // mes seleccionado para vista semanal
  const [totales, setTotales] = useState({
    enviados: 0,
    vistos: 0,
    firmados: 0
  });

  // ASISTENCIA
  const [loadingAsistencias, setLoadingAsistencias] = useState(true);
  const [errorAsistencias, setErrorAsistencias] = useState(null);
  const [indicadoresAsistencia, setIndicadoresAsistencia] = useState(null);
  const [mesAsistencia, setMesAsistencia] = useState(MESES_VALOR[new Date().getMonth()]);
  const [anioAsistencia, setAnioAsistencia] = useState(new Date().getFullYear());

  // PLANILLAS
  const [loadingPlanillas, setLoadingPlanillas] = useState(true);
  const [errorPlanillas, setErrorPlanillas] = useState(null);
  const [indicadoresPlanilla, setIndicadoresPlanilla] = useState(null);

  // CONTABILIDAD
  const [loadingContabilidad, setLoadingContabilidad] = useState(true);
  const [errorContabilidad, setErrorContabilidad] = useState(null);
  const [indicadoresContables, setIndicadoresContables] = useState(null);

  // USUARIOS: Solo momento actual
  useEffect(() => {
    if (!dashboardCargado) return;
    const fetchUsuarios = async () => {
      setLoadingUsuarios(true);
      setErrorUsuarios(null);
      try {
        if (!usuario?.rucEmpresa && !usuario?.ruc) throw new Error("RUC no disponible");
        const ruc = usuario.rucEmpresa || usuario.ruc;
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("rucEmpresa", "==", ruc));
        // Marca el origen de esta lectura para el seguimiento de consumo.
        establecerOrigenConsumo("dashboard:usuarios");
        const snapshot = await getDocs(q);

        let total = 0;
        let activos = 0;
        let firmas = 0;

        const now = new Date();
        const currentMonth = now.getMonth(); // 0-11
        const currentYear = now.getFullYear();

        const dnis = [];
        snapshot.forEach((docUser) => {
          total++;
          const data = docUser.data();

          if (data.lastActive) {
            const lastActiveDate = new Date(data.lastActive);
            if (
              lastActiveDate.getFullYear() === currentYear &&
              lastActiveDate.getMonth() === currentMonth
            ) {
              activos++;
            }
          }

          if (data.dni) {
            dnis.push(data.dni);
          }
        });

        // OPTIMIZACIÓN: Consultar todas las firmas activas de la empresa en una sola consulta
        if (dnis.length > 0) {
          const activeDnisSet = new Set(dnis);
          const firmasRef = collection(db, "firmas");
          const qFirmas = query(
            firmasRef,
            where("ruc", "==", ruc),
            where("activo", "==", true)
          );
          establecerOrigenConsumo("dashboard:firmas");
          const firmasSnap = await getDocs(qFirmas);
          firmasSnap.forEach((docFirma) => {
            const fd = docFirma.data();
            if (fd.dni && activeDnisSet.has(fd.dni)) {
              firmas++;
            }
          });
        }

        setUsuariosTotales(total);
        setUsuariosActivos(activos);
        setUsuariosFirmas(firmas);
      } catch (err) {
        setErrorUsuarios(err.message);
      } finally {
        setLoadingUsuarios(false);
      }
    };
    fetchUsuarios();
    // eslint-disable-next-line
  }, [usuario?.rucEmpresa, usuario?.ruc, dashboardCargado]);

  // GESTIÓN DOCUMENTAL: Carga inicial
  useEffect(() => {
    if (!dashboardCargado) return;
    const fetchData = async () => {
      setLoadingDocumentos(true);
      setError(null);

      try {
        if (!usuario?.rucEmpresa && !usuario?.ruc) {
          throw new Error("RUC no disponible");
        }
        const ruc = usuario.rucEmpresa || usuario.ruc;

        // Trae los datos agrupados por mes y por semana
        establecerOrigenConsumo("dashboard:documentos");
        const docData = await contadorDocumentos(ruc, year, tipoDocumento);

        setDataDocumentos(docData.mensual);
        setDataVistos(docData.vistos);
        setDataFirmados(docData.firmados);
        setDataSemanalRaw(docData.semanal || {});

        setTotales({
          enviados: docData.total || 0,
          vistos: docData.totalVistos || 0,
          firmados: docData.totalFirmados || 0
        });

      } catch (err) {
        setError(err.message);
      } finally {
        setLoadingDocumentos(false);
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, [usuario?.rucEmpresa, usuario?.ruc, year, tipoDocumento, dashboardCargado]);

  // Procesar las semanas localmente sin volver a consultar Firestore al cambiar de mes
  useEffect(() => {
    let dataSemanalFiltrada = {};
    if (dataSemanalRaw) {
      Object.keys(dataSemanalRaw).forEach(key => {
        const [mes, semana] = key.split("-");
        if (mes === periodo) {
          const match = semana.match(/(\d+)/);
          if (match) {
            const semanaNum = match[1].toString().padStart(2, "0");
            dataSemanalFiltrada[semanaNum] = dataSemanalRaw[key];
          }
        }
      });
    }

    // Ordenar por número de semana
    const dataSemanalOrdenada = {};
    Object.keys(dataSemanalFiltrada)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .forEach(semanaNum => {
        dataSemanalOrdenada[semanaNum] = dataSemanalFiltrada[semanaNum];
      });

    setDataSemanal(dataSemanalOrdenada);
  }, [periodo, dataSemanalRaw]);

  // GESTIÓN PLANILLAS: KPIs y gráfico
  useEffect(() => {
    if (!dashboardCargado) return;
    const fetchPlanillaData = async () => {
      setLoadingPlanillas(true);
      setErrorPlanillas(null);
      try {
        if (!usuario?.rucEmpresa && !usuario?.ruc) throw new Error("RUC no disponible");
        const ruc = usuario.rucEmpresa || usuario.ruc;
        establecerOrigenConsumo("dashboard:planilla");
        const data = await obtenerIndicadoresPlanilla({ rucEmpresa: ruc, year });
        setIndicadoresPlanilla(data);
      } catch (err) {
        setErrorPlanillas(err.message);
      } finally {
        setLoadingPlanillas(false);
      }
    };
    fetchPlanillaData();
    // eslint-disable-next-line
  }, [usuario?.rucEmpresa, usuario?.ruc, year, dashboardCargado]);

  // GESTIÓN ASISTENCIA: KPIs y gráfico
  useEffect(() => {
    if (!dashboardCargado) return;
    const fetchIndicadores = async () => {
      setLoadingAsistencias(true);
      setErrorAsistencias(null);
      try {
        if (!usuario?.rucEmpresa && !usuario?.ruc) throw new Error("RUC no disponible");
        const ruc = usuario.rucEmpresa || usuario.ruc;
        establecerOrigenConsumo("dashboard:asistencia");
        const indicadores = await obtenerIndicadoresAsistencia({
          rucEmpresa: ruc,
          year: anioAsistencia,
          month: mesAsistencia
        });
        setIndicadoresAsistencia(indicadores);
      } catch (err) {
        setErrorAsistencias(err.message);
      } finally {
        setLoadingAsistencias(false);
      }
    };
    fetchIndicadores();
    // eslint-disable-next-line
  }, [usuario?.rucEmpresa, usuario?.ruc, anioAsistencia, mesAsistencia, dashboardCargado]);

  // GESTIÓN CONTABLE: Carga de Estados Financieros
  useEffect(() => {
    if (!dashboardCargado) return;
    const fetchContableData = async () => {
      setLoadingContabilidad(true);
      setErrorContabilidad(null);
      try {
        if (!usuario?.rucEmpresa && !usuario?.ruc) throw new Error("RUC no disponible");
        const ruc = usuario.rucEmpresa || usuario.ruc;
        
        // Obtener periodo actual YYYY-MM
        const now = new Date();
        const periodo = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

        establecerOrigenConsumo("dashboard:contabilidad");
        const data = await obtenerReporteFinanciero(ruc, periodo);
        setIndicadoresContables(data);
      } catch (err) {
        setErrorContabilidad(err.message);
      } finally {
        setLoadingContabilidad(false);
      }
    };
    fetchContableData();
    // eslint-disable-next-line
  }, [usuario?.rucEmpresa, usuario?.ruc, dashboardCargado]);

  // Gráficos DOCUMENTOS
  const chartData = {
    labels: MESES,
    datasets: [
      {
        label: "Enviados",
        data: Object.values(dataDocumentos),
        backgroundColor: "rgba(255, 99, 132, 0.25)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 3,
        borderRadius: 12,
        barPercentage: 0.65,
        categoryPercentage: 0.55,
        hoverBackgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Vistos",
        data: Object.values(dataVistos),
        backgroundColor: "rgba(54, 162, 235, 0.25)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 3,
        borderRadius: 12,
        barPercentage: 0.65,
        categoryPercentage: 0.55,
        hoverBackgroundColor: "rgba(54, 162, 235, 0.5)",
      },
      {
        label: "Firmados",
        data: Object.values(dataFirmados),
        backgroundColor: "rgba(75, 192, 192, 0.25)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 3,
        borderRadius: 12,
        barPercentage: 0.65,
        categoryPercentage: 0.55,
        hoverBackgroundColor: "rgba(75, 192, 192, 0.5)",
      },
    ],
  };

  const chartDataSemanal = {
    labels: Object.keys(dataSemanal), // ["01", "02", ...]
    datasets: [
      {
        label: "Documentos por Semana",
        data: Object.values(dataSemanal),
        backgroundColor: COLORS.slice(0, Object.keys(dataSemanal).length),
        borderColor: "#fff",
        borderWidth: 2,
        borderRadius: 10,
        hoverBackgroundColor: COLORS.slice(0, Object.keys(dataSemanal).length).map(c => c + "CC"),
      }
    ],
  };

  const doughnutData = {
    labels: ["Enviados", "Vistos", "Firmados"],
    datasets: [
      {
        data: [totales.enviados, totales.vistos, totales.firmados],
        backgroundColor: [
          "rgba(255, 99, 132, 0.85)",
          "rgba(54, 162, 235, 0.85)",
          "rgba(75, 192, 192, 0.85)"
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(75, 192, 192, 1)"
        ],
        borderWidth: 3,
        hoverOffset: 12,
      }
    ]
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 15, weight: "bold" }, color: "#1a237e" }
      },
      y: {
        beginAtZero: true,
        grid: { color: "#e6e6e6" },
        ticks: { font: { size: 15, weight: "bold" }, color: "#1a237e" }
      },
    },
    plugins: {
      legend: { position: 'top', labels: { font: { size: 17, weight: "bold" }, color: "#1a237e" } },
      tooltip: { enabled: true }
    },
    animation: {
      duration: 1200,
      easing: "easeOutQuart"
    }
  };

  // Años disponibles para selector (puedes ajustar el rango)
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 6; i++) {
    years.push(currentYear - i);
  }

  // Tooltip helpers
  const renderTooltip = (msg) => (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{msg}</Tooltip>}
    >
      <span style={{ cursor: "pointer", color: "#4a9eff" }}> ⓘ </span>
    </OverlayTrigger>
  );

  return (
    <Container
      fluid
      className="py-4"
      style={{
        background: "linear-gradient(135deg, #e3f0ff 0%, #f8fafc 100%)",
        minHeight: "100vh",
      }}
    >
      {/* Título principal */}
      <Row className="mb-4">
        <Col className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div className="d-flex align-items-center gap-3">
            <FaChartBar style={{ fontSize: 38, color: "#1976d2" }} />
            <div>
              <h1 className="fw-bold mb-0" style={{ letterSpacing: 1, color: "#0d47a1" }}>
                Dashboard Mi Boleta
              </h1>
              <span className="text-muted" style={{ fontSize: "0.95rem" }}>
                Bienvenido/a, {usuario?.nombre || usuario?.email || "Administrador"}
              </span>
            </div>
          </div>
          <Button
            variant={dashboardCargado ? "outline-primary" : "primary"}
            size="lg"
            className="shadow-sm fw-bold px-4 py-2"
            onClick={() => setDashboardCargado(prev => !prev)}
            style={{ borderRadius: 12 }}
          >
            <FaChartBar className="me-2" />
            {dashboardCargado ? "Ocultar / Pausar Dashboard" : "📊 Cargar Dashboard y Estadísticas"}
          </Button>
        </Col>
      </Row>

      {!dashboardCargado ? (
        <>
          {/* Banner Hero de Bienvenida */}
          <Card 
            className="shadow-sm border-0 mb-4 overflow-hidden" 
            style={{ 
              borderRadius: 24, 
              background: "linear-gradient(135deg, #0d47a1 0%, #1565c0 50%, #1976d2 100%)",
              color: "#ffffff" 
            }}
          >
            <Card.Body className="p-4 p-md-5">
              <Row className="align-items-center">
                <Col lg={8} className="mb-4 mb-lg-0">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <Badge bg="light" className="text-primary fw-bold px-3 py-2" style={{ borderRadius: 10, fontSize: "0.85rem" }}>
                      <FaShieldAlt className="me-1" /> Rol: {usuario?.rol || "Administrador"}
                    </Badge>
                    {usuario?.empresa && (
                      <Badge bg="warning" className="text-dark fw-bold px-3 py-2" style={{ borderRadius: 10, fontSize: "0.85rem" }}>
                        <FaBuilding className="me-1" /> {usuario.empresa}
                      </Badge>
                    )}
                  </div>
                  <h1 className="fw-bold mb-2" style={{ fontSize: "2.2rem", letterSpacing: "-0.5px" }}>
                    ¡Hola, {usuario?.nombre || usuario?.email || "Administrador"}! 👋
                  </h1>
                  <p className="mb-4 text-white-50" style={{ fontSize: "1.1rem", maxWidth: 620 }}>
                    Bienvenido al Centro de Control. Selecciona una acción rápida o activa las analíticas completas de tu organización cuando lo requieras.
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    <Button
                      variant="light"
                      size="lg"
                      className="fw-bold text-primary px-4 py-2 shadow-sm"
                      onClick={() => setDashboardCargado(true)}
                      style={{ borderRadius: 14, fontSize: "1rem" }}
                    >
                      <FaChartBar className="me-2" />
                      📊 Cargar Estadísticas y Métricas
                    </Button>
                  </div>
                </Col>

                <Col lg={4} className="text-center text-lg-end">
                  <div 
                    className="d-inline-flex p-4 rounded-circle shadow-lg"
                    style={{ 
                      background: "rgba(255, 255, 255, 0.15)", 
                      backdropFilter: "blur(10px)",
                      border: "2px solid rgba(255, 255, 255, 0.2)"
                    }}
                  >
                    <FaRocket style={{ fontSize: 64, color: "#ffffff" }} />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Sección de Accesos Rápidos Categorizados */}
          <h4 className="fw-bold mb-3 text-dark d-flex align-items-center gap-2">
            <FaMagic className="text-primary" /> Accesos Rápidos del Sistema
          </h4>

          <Row className="g-4 mb-4">
            {/* Categoría 1: Gestión de Personal */}
            <Col md={6} lg={3}>
              <Card className="h-100 shadow-sm border-0 transition-all card-hover" style={{ borderRadius: 18, background: "#ffffff" }}>
                <Card.Body className="p-4 d-flex flex-column">
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="p-3 rounded-3" style={{ background: "rgba(25, 118, 210, 0.1)", color: "#1976d2" }}>
                      <FaUsers style={{ fontSize: 26 }} />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0 text-dark">Personal</h5>
                      <span className="text-muted small">Usuarios y CECOs</span>
                    </div>
                  </div>
                  <p className="text-muted small mb-4 flex-grow-1">
                    Administra legajos, permisos, centros de costos y firmas del personal.
                  </p>
                  <div className="d-grid gap-2">
                    <Link to="/usuarios" className="btn btn-outline-primary btn-sm fw-bold rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaUsers className="me-2" />Lista de Usuarios</span>
                      <FaArrowRight />
                    </Link>
                    <Link to="/centro-costos" className="btn btn-light btn-sm text-dark rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaBuilding className="me-2" />Centro de Costos</span>
                      <FaArrowRight />
                    </Link>
                    <Link to="/usuarios-con-firma" className="btn btn-light btn-sm text-dark rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaUserCheck className="me-2" />Firmas Electrónicas</span>
                      <FaArrowRight />
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Categoría 2: Gestión Documental */}
            <Col md={6} lg={3}>
              <Card className="h-100 shadow-sm border-0 transition-all card-hover" style={{ borderRadius: 18, background: "#ffffff" }}>
                <Card.Body className="p-4 d-flex flex-column">
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="p-3 rounded-3" style={{ background: "rgba(156, 39, 176, 0.1)", color: "#9c27b0" }}>
                      <FaFileAlt style={{ fontSize: 26 }} />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0 text-dark">Documental</h5>
                      <span className="text-muted small">Boletas y Contratos</span>
                    </div>
                  </div>
                  <p className="text-muted small mb-4 flex-grow-1">
                    Carga masiva de boletas, contratos, comunicados y firma de documentos.
                  </p>
                  <div className="d-grid gap-2">
                    <Link to="/documentos" className="btn btn-outline-purple btn-sm fw-bold rounded-3 text-start d-flex justify-content-between align-items-center" style={{ color: "#9c27b0", borderColor: "#9c27b0" }}>
                      <span><FaFolderOpen className="me-2" />Boletas y Documentos</span>
                      <FaArrowRight />
                    </Link>
                    <Link to="/masivos" className="btn btn-light btn-sm text-dark rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaFileInvoice className="me-2" />Carga Masiva</span>
                      <FaArrowRight />
                    </Link>
                    <Link to="/documentos/contratos" className="btn btn-light btn-sm text-dark rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaFileAlt className="me-2" />Generador Contratos</span>
                      <FaArrowRight />
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Categoría 3: Control de Asistencias & Rutas */}
            <Col md={6} lg={3}>
              <Card className="h-100 shadow-sm border-0 transition-all card-hover" style={{ borderRadius: 18, background: "#ffffff" }}>
                <Card.Body className="p-4 d-flex flex-column">
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="p-3 rounded-3" style={{ background: "rgba(0, 150, 136, 0.1)", color: "#009688" }}>
                      <FaClock style={{ fontSize: 26 }} />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0 text-dark">Asistencias</h5>
                      <span className="text-muted small">Ingresos y Rutas</span>
                    </div>
                  </div>
                  <p className="text-muted small mb-4 flex-grow-1">
                    Reporte de asistencias de personal, transporte de buses y marcaciones.
                  </p>
                  <div className="d-grid gap-2">
                    <Link to="/reporte-ingresos" className="btn btn-outline-success btn-sm fw-bold rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaClock className="me-2" />Reporte de Ingresos</span>
                      <FaArrowRight />
                    </Link>
                    <Link to="/asistencia/transporte" className="btn btn-light btn-sm text-dark rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaBus className="me-2" />Gestión Transporte</span>
                      <FaArrowRight />
                    </Link>
                    <Link to="/asistencia/trazabilidad" className="btn btn-light btn-sm text-dark rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaBus className="me-2" />Trazabilidad Rutas</span>
                      <FaArrowRight />
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Categoría 4: Agentes AI */}
            <Col md={6} lg={3}>
              <Card className="h-100 shadow-sm border-0 transition-all card-hover" style={{ borderRadius: 18, background: "#ffffff" }}>
                <Card.Body className="p-4 d-flex flex-column">
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="p-3 rounded-3" style={{ background: "rgba(255, 152, 0, 0.1)", color: "#ff9800" }}>
                      <FaRobot style={{ fontSize: 26 }} />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0 text-dark">Agentes IA</h5>
                      <span className="text-muted small">Smart Recruiting</span>
                    </div>
                  </div>
                  <p className="text-muted small mb-4 flex-grow-1">
                    Potencia tu selección de personal con agentes Hiro, Vexa y Axis AI.
                  </p>
                  <div className="d-grid gap-2">
                    <Link to="/documentos/procesador/hiro" className="btn btn-outline-warning btn-sm fw-bold text-dark rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaBrain className="me-2 text-warning" />Hiro CV Processor</span>
                      <FaArrowRight />
                    </Link>
                    <Link to="/documentos/procesador/chat-hiro" className="btn btn-light btn-sm text-dark rounded-3 text-start d-flex justify-content-between align-items-center">
                      <span><FaRobot className="me-2" />Chat con Hiro AI</span>
                      <FaArrowRight />
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      ) : (
        <>

      {/* DASHBOARD USUARIOS */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex align-items-center gap-2 mb-2">
            <FaUsers style={{ fontSize: 32, color: "#1a237e" }} />
            <h2 className="fw-bold mb-0" style={{ letterSpacing: 1, color: "#1a237e" }}>
              Gestión de Usuarios
            </h2>
          </div>
          <div className="text-muted" style={{ fontSize: 16, marginLeft: 4 }}>
            Seguimiento de usuarios registrados, activos y con firma electrónica
          </div>
        </Col>
      </Row>

      {loadingUsuarios ? (
        <Row className="mb-4 g-4">
          {[1, 2, 3].map(i => (
            <Col key={i} md={4}>
              <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
                <Card.Body className="text-center py-4">
                  <div className="skeleton mb-2" style={{ width: 40, height: 40, borderRadius: "50%", margin: "0 auto" }}></div>
                  <div className="skeleton mb-2" style={{ width: "60%", height: 20, margin: "0 auto" }}></div>
                  <div className="skeleton" style={{ width: "80%", height: 60, borderRadius: 12, margin: "0 auto" }}></div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <Row className="mb-4 g-4">
          <Col md={4}>
            <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
              <Card.Body className="text-center py-4">
                <div className="mb-2">
                  <FaUsers style={{ fontSize: 36, color: "#36a2eb" }} />
                </div>
                <h5 className="fw-bold mb-2" style={{ color: "#36a2eb" }}>
                  Usuarios Totales {renderTooltip("Cantidad total de usuarios registrados")}
                </h5>
                <h2>
                  <Badge bg="primary" style={{ fontSize: 36, padding: "12px 28px" }}>{usuariosTotales}</Badge>
                </h2>
                <div className="text-muted mt-2">Usuarios registrados</div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
              <Card.Body className="text-center py-4">
                <div className="mb-2">
                  <FaUserClock style={{ fontSize: 36, color: "#4bc0c0" }} />
                </div>
                <h5 className="fw-bold mb-2" style={{ color: "#4bc0c0" }}>
                  Usuarios Activos {renderTooltip("Usuarios que han iniciado sesión este mes")}
                </h5>
                <h2>
                  <Badge bg="success" style={{ fontSize: 36, padding: "12px 28px" }}>{usuariosActivos}</Badge>
                </h2>
                <div className="text-muted mt-2">Activos este mes</div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
              <Card.Body className="text-center py-4">
                <div className="mb-2">
                  <MdOutlineVerifiedUser style={{ fontSize: 36, color: "#FFCE56" }} />
                </div>
                <h5 className="fw-bold mb-2" style={{ color: "#FFCE56" }}>
                  Usuarios con Firma {renderTooltip("Usuarios con firma electrónica generada")}
                </h5>
                <h2>
                  <Badge bg="warning" text="dark" style={{ fontSize: 36, padding: "12px 28px" }}>
                    {usuariosFirmas}
                  </Badge>
                </h2>
                <div className="text-muted mt-2">Con firma electrónica</div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* DASHBOARD DOCUMENTAL */}
      <Row className="mb-4 mt-5">
        <Col>
          <div className="d-flex align-items-center gap-2 mb-2">
            <HiOutlineDocumentReport style={{ fontSize: 32, color: "#1a237e" }} />
            <h2 className="fw-bold mb-0" style={{ letterSpacing: 1, color: "#1a237e" }}>
              Gestión Documental
            </h2>
          </div>
          <div className="text-muted" style={{ fontSize: 16, marginLeft: 4 }}>
            Seguimiento de documentos enviados, vistos y firmados
          </div>
        </Col>
      </Row>
      {loadingDocumentos ? (
        <Row className="mb-4 g-4">
          {[1, 2, 3].map(i => (
            <Col key={i} md={4}>
              <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
                <Card.Body className="text-center py-4">
                  <div className="skeleton mb-2" style={{ width: 40, height: 40, borderRadius: "50%", margin: "0 auto" }}></div>
                  <div className="skeleton mb-2" style={{ width: "60%", height: 20, margin: "0 auto" }}></div>
                  <div className="skeleton" style={{ width: "80%", height: 60, borderRadius: 12, margin: "0 auto" }}></div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <Row className="mb-4 g-4">
          <Col md={4}>
            <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
              <Card.Body className="text-center py-4">
                <div className="mb-2">
                  <FaFileAlt style={{ fontSize: 34, color: "#ff6384" }} />
                </div>
                <h5 className="fw-bold mb-2" style={{ color: "#ff6384" }}>
                  Enviados {renderTooltip("Total de documentos enviados")}
                </h5>
                <h2>
                  <Badge bg="danger" style={{ fontSize: 36, padding: "12px 28px" }}>{totales.enviados}</Badge>
                </h2>
                <div className="text-muted mt-2">Documentos enviados</div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
              <Card.Body className="text-center py-4">
                <div className="mb-2">
                  <FaRegChartBar style={{ fontSize: 34, color: "#36a2eb" }} />
                </div>
                <h5 className="fw-bold mb-2" style={{ color: "#36a2eb" }}>
                  Vistos {renderTooltip("Total de documentos visualizados")}
                </h5>
                <h2>
                  <Badge bg="primary" style={{ fontSize: 36, padding: "12px 28px" }}>{totales.vistos}</Badge>
                </h2>
                <div className="text-muted mt-2">Documentos visualizados</div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
              <Card.Body className="text-center py-4">
                <div className="mb-2">
                  <FaUserCheck style={{ fontSize: 34, color: "#4bc0c0" }} />
                </div>
                <h5 className="fw-bold mb-2" style={{ color: "#4bc0c0" }}>
                  Firmados {renderTooltip("Total de documentos firmados")}
                </h5>
                <h2>
                  <Badge bg="success" style={{ fontSize: 36, padding: "12px 28px" }}>{totales.firmados}</Badge>
                </h2>
                <div className="text-muted mt-2">Documentos firmados</div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      <Row className="mb-4 g-4">
        <Col md={8}>
          <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
            <Card.Body>
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group controlId="yearSelector">
                    <Form.Label className="fw-semibold">Año</Form.Label>
                    <Form.Control
                      as="select"
                      value={year}
                      onChange={e => setYear(Number(e.target.value))}
                      style={{ borderRadius: 10, fontWeight: 500, fontSize: 16 }}
                    >
                      {years.map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="viewTypeSelector">
                    <Form.Label className="fw-semibold">Tipo de Vista</Form.Label>
                    <Form.Control
                      as="select"
                      value={viewType}
                      onChange={(e) => setViewType(e.target.value)}
                      style={{ borderRadius: 10, fontWeight: 500, fontSize: 16 }}
                    >
                      <option value="mensual">Mensual</option>
                      <option value="semanal">Semanal</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="docTypeSelector">
                    <Form.Label className="fw-semibold">Tipo Documento</Form.Label>
                    <Form.Control
                      as="select"
                      value={tipoDocumento}
                      onChange={(e) => setTipoDocumento(e.target.value)}
                      style={{ borderRadius: 10, fontWeight: 500, fontSize: 16 }}
                    >
                      {TIPOS_DOCUMENTO.map(t => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                {viewType === "semanal" && (
                  <Col md={3}>
                    <Form.Group controlId="periodoSelector">
                      <Form.Label className="fw-semibold">Mes</Form.Label>
                      <Form.Control
                        as="select"
                        value={periodo}
                        onChange={e => setPeriodo(e.target.value)}
                        style={{ borderRadius: 10, fontWeight: 500, fontSize: 16 }}
                      >
                        {MESES_VALOR.map((val, idx) => (
                          <option key={val} value={val}>{MESES[idx]}</option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                )}
              </Row>
              <div style={{ minHeight: 370 }}>
                {loadingDocumentos ? (
                  <div className="py-2">
                    <div className="skeleton mb-4" style={{ width: "40%", height: 25 }}></div>
                    <div className="skeleton" style={{ width: "100%", height: 320 }}></div>
                  </div>
                ) : error ? (
                  <div className="text-danger text-center py-5">{error}</div>
                ) : (
                  <>
                    <h5 className="fw-bold mb-3" style={{ color: "#1a237e" }}>
                      {viewType === 'mensual' ? 'Documentos por Mes' : 'Documentos por Semana'}
                    </h5>
                    {viewType === 'mensual' ? (
                      <Bar data={chartData} options={options} />
                    ) : (
                      <Bar data={chartDataSemanal} options={{
                        ...options,
                        scales: {
                          ...options.scales,
                          x: {
                            ...options.scales.x,
                            ticks: {
                              maxRotation: 45,
                              minRotation: 45
                            }
                          }
                        }
                      }} />
                    )}
                  </>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow border-0" style={{ borderRadius: 18, minHeight: 440, background: "#fff" }}>
            <Card.Body>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FaChartPie style={{ fontSize: 28, color: "#1a237e" }} />
                <h5 className="fw-bold mb-0" style={{ color: "#1a237e" }}>Resumen General</h5>
              </div>
              {loadingDocumentos ? (
                <div className="py-4">
                  <div className="d-flex justify-content-center">
                    <div className="skeleton" style={{ width: 250, height: 250, borderRadius: "50%" }}></div>
                  </div>
                  <div className="mt-4">
                    <div className="skeleton mb-2" style={{ width: "80%", height: 15, margin: "0 auto" }}></div>
                    <div className="skeleton mb-2" style={{ width: "70%", height: 15, margin: "0 auto" }}></div>
                    <div className="skeleton" style={{ width: "75%", height: 15, margin: "0 auto" }}></div>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ maxWidth: 320, margin: "0 auto" }}>
                    <Doughnut data={doughnutData} options={{
                      plugins: {
                        legend: { position: "bottom", labels: { font: { size: 16, weight: "bold" }, color: "#1a237e" } }
                      }
                    }} />
                  </div>
                  <div className="mt-4 text-center text-muted" style={{ fontSize: 16 }}>
                    <div>
                      <span style={{ color: "#ff6384", fontWeight: 700 }}>●</span> Enviados: <b>{totales.enviados}</b>
                    </div>
                    <div>
                      <span style={{ color: "#36a2eb", fontWeight: 700 }}>●</span> Vistos: <b>{totales.vistos}</b>
                    </div>
                    <div>
                      <span style={{ color: "#4bc0c0", fontWeight: 700 }}>●</span> Firmados: <b>{totales.firmados}</b>
                    </div>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* DASHBOARD PLANILLAS */}
      <Row className="mb-4 mt-5">
        <Col>
          <div className="d-flex align-items-center gap-2 mb-2">
            <TbReportMoney style={{ fontSize: 32, color: "#2e7d32" }} />
            <h2 className="fw-bold mb-0" style={{ letterSpacing: 1, color: "#2e7d32" }}>
              Gestión de Planillas y Costos
            </h2>
          </div>
          <div className="text-muted" style={{ fontSize: 16, marginLeft: 4 }}>
            Análisis de costos laborales, aportaciones y pagos netos
          </div>
        </Col>
      </Row>

      {loadingPlanillas ? (
        <Row className="mb-4 g-4">
          {[1, 2, 3, 4].map(i => (
            <Col key={i} md={3}>
              <Card className="shadow border-0 h-100" style={{ borderRadius: 18 }}>
                <Card.Body className="text-center py-4">
                  <div className="skeleton mb-2" style={{ width: 30, height: 30, margin: "0 auto" }}></div>
                  <div className="skeleton mb-2" style={{ width: "70%", height: 15, margin: "0 auto" }}></div>
                  <div className="skeleton" style={{ width: "90%", height: 35, margin: "0 auto" }}></div>
                </Card.Body>
              </Card>
            </Col>
          ))}
          <Col md={12} className="mt-4">
            <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
              <Card.Body>
                <div className="skeleton mb-4" style={{ width: "30%", height: 25 }}></div>
                <div className="skeleton" style={{ width: "100%", height: 300 }}></div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : errorPlanillas ? (
        <Row className="mb-4">
          <Col className="text-danger text-center py-5">{errorPlanillas}</Col>
        </Row>
      ) : indicadoresPlanilla?.hayDatos ? (
        <>
          <Row className="mb-4 g-4">
            <Col md={3}>
              <Card className="shadow border-0 h-100" style={{ borderRadius: 18, borderLeft: "6px solid #f44336" }}>
                <Card.Body className="text-center py-4">
                  <div className="mb-2">
                    <FaCalculator style={{ fontSize: 30, color: "#f44336" }} />
                  </div>
                  <h6 className="fw-bold mb-1 text-muted">Costo Laboral Total</h6>
                  <h3 className="fw-bold mb-0" style={{ color: "#f44336" }}>
                    S/ {indicadoresPlanilla.ultima.costoLaboralTotal.toLocaleString('es-PE', { minimumFractionDigits: 2 })}
                  </h3>
                  <div className="small text-muted mt-2">Última planilla ({indicadoresPlanilla.ultima.periodo})</div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="shadow border-0 h-100" style={{ borderRadius: 18, borderLeft: "6px solid #4caf50" }}>
                <Card.Body className="text-center py-4">
                  <div className="mb-2">
                    <FaWallet style={{ fontSize: 30, color: "#4caf50" }} />
                  </div>
                  <h6 className="fw-bold mb-1 text-muted">Neto a Pagar</h6>
                  <h3 className="fw-bold mb-0" style={{ color: "#4caf50" }}>
                    S/ {indicadoresPlanilla.ultima.netoPagar.toLocaleString('es-PE', { minimumFractionDigits: 2 })}
                  </h3>
                  <div className="small text-muted mt-2">Desembolso inmediato</div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="shadow border-0 h-100" style={{ borderRadius: 18, borderLeft: "6px solid #fb8c00" }}>
                <Card.Body className="text-center py-4">
                  <div className="mb-2">
                    <HiOutlineReceiptTax style={{ fontSize: 30, color: "#fb8c00" }} />
                  </div>
                  <h6 className="fw-bold mb-1 text-muted">Carga Prestacional</h6>
                  <h3 className="fw-bold mb-0" style={{ color: "#fb8c00" }}>
                    S/ {indicadoresPlanilla.ultima.cargaPrestacional.toLocaleString('es-PE', { minimumFractionDigits: 2 })}
                  </h3>
                  <div className="small text-muted mt-2">Aportes y Provisiones</div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="shadow border-0 h-100" style={{ borderRadius: 18, borderLeft: "6px solid #1976d2" }}>
                <Card.Body className="text-center py-4">
                  <div className="mb-2">
                    <FaUsers style={{ fontSize: 30, color: "#1976d2" }} />
                  </div>
                  <h6 className="fw-bold mb-1 text-muted">Personal en Planilla</h6>
                  <h3 className="fw-bold mb-0" style={{ color: "#1976d2" }}>
                    {indicadoresPlanilla.ultima.numEmpleados}
                  </h3>
                  <div className="small text-muted mt-2">Colaboradores vigentes</div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={12}>
              <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff" }}>
                <Card.Body>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <BsGraphUp style={{ fontSize: 24, color: "#2e7d32" }} />
                    <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>Evolución de Costos Anual</h5>
                  </div>
                  <div style={{ minHeight: 300, maxHeight: 400 }}>
                    <Line
                      data={indicadoresPlanilla.chartData}
                      options={{
                        ...options,
                        plugins: {
                          ...options.plugins,
                          tooltip: {
                            callbacks: {
                              label: function (context) {
                                let label = context.dataset.label || '';
                                if (label) label += ': ';
                                if (context.parsed.y !== null) {
                                  label += new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(context.parsed.y);
                                }
                                return label;
                              }
                            }
                          }
                        }
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      ) : (
        <Row className="mb-4 text-center py-5">
          <Col>
            <div className="text-muted" style={{ fontSize: 18 }}>
              No hay planillas procesadas para el año {year}.
            </div>
          </Col>
        </Row>
      )}

      {/* DASHBOARD ASISTENCIAS Y AUSENCIAS */}
      <Row className="mb-4 mt-5">
        <Col>
          <div className="d-flex align-items-center gap-2 mb-2">
            <BsFillPersonCheckFill style={{ fontSize: 32, color: "#1976d2" }} />
            <h2 className="fw-bold mb-0" style={{ letterSpacing: 1, color: "#1976d2" }}>
              Gestión de Asistencias y Ausencias
            </h2>
          </div>
          <div className="text-muted" style={{ fontSize: 16, marginLeft: 4 }}>
            Control y seguimiento de asistencias y ausencias del personal
          </div>
        </Col>
      </Row>
      <Row className="mb-4 g-4">
        <Col md={12}>
          <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff", minHeight: 220 }}>
            <Card.Body>
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Año</Form.Label>
                    <Form.Control
                      as="select"
                      value={anioAsistencia}
                      onChange={e => setAnioAsistencia(Number(e.target.value))}
                      style={{ borderRadius: 10, fontWeight: 500, fontSize: 16 }}
                    >
                      {years.map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Mes</Form.Label>
                    <Form.Control
                      as="select"
                      value={mesAsistencia}
                      onChange={e => setMesAsistencia(e.target.value)}
                      style={{ borderRadius: 10, fontWeight: 500, fontSize: 16 }}
                    >
                      {MESES_VALOR.map((val, idx) => (
                        <option key={val} value={val}>{MESES[idx]}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              {loadingAsistencias ? (
                <Row className="g-3">
                  {[1, 2, 3, 4, 5, 6].map(i => (
                    <Col key={i} md={2}>
                      <Card className="h-100">
                        <Card.Body className="text-center">
                          <div className="skeleton mb-2" style={{ width: "80%", height: 40, margin: "0 auto" }}></div>
                          <div className="skeleton" style={{ width: "60%", height: 15, margin: "0 auto" }}></div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                  <Col md={12} className="mt-4">
                    <div className="skeleton mb-4" style={{ width: "30%", height: 25 }}></div>
                    <div className="skeleton" style={{ width: "100%", height: 180 }}></div>
                  </Col>
                </Row>
              ) : errorAsistencias ? (
                <div className="text-danger text-center py-5">{errorAsistencias}</div>
              ) : indicadoresAsistencia ? (
                <>
                  <Row className="mb-4">
                    <Col md={2}>
                      <Card className="h-100 border-primary">
                        <Card.Body className="text-center">
                          <h1 className="display-6 text-primary">
                            {indicadoresAsistencia.totalEmployees}
                          </h1>
                          <p className="text-muted mb-0" style={{ fontSize: 15 }}>Empleados</p>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={2}>
                      <Card className="h-100 border-success">
                        <Card.Body className="text-center">
                          <h1 className="display-6 text-success">
                            {indicadoresAsistencia.attendanceRate?.toFixed(1)}%
                          </h1>
                          <p className="text-muted mb-0" style={{ fontSize: 15 }}>
                            Tasa de Asistencia
                            <br />
                            <span style={{ fontSize: "0.9em" }}>
                              Objetivo a la fecha: {indicadoresAsistencia.objetivoAFecha?.toFixed(1)}%
                            </span>
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={2}>
                      <Card className="h-100 border-danger">
                        <Card.Body className="text-center">
                          <h1 className="display-6 text-danger">
                            {indicadoresAsistencia.absenceRate?.toFixed(1)}%
                          </h1>
                          <p className="text-muted mb-0" style={{ fontSize: 15 }}>
                            Tasa de Ausencia
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={2}>
                      <Card className="h-100 border-warning">
                        <Card.Body className="text-center">
                          <h1 className="display-6 text-warning">
                            {indicadoresAsistencia.lateArrivals}
                          </h1>
                          <p className="text-muted mb-0" style={{ fontSize: 15 }}>
                            Llegadas tarde
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={2}>
                      <Card className="h-100 border-info">
                        <Card.Body className="text-center">
                          <h1 className="display-6 text-info">
                            {indicadoresAsistencia.porcentajePerfectos?.toFixed(1)}%
                          </h1>
                          <p className="text-muted mb-0" style={{ fontSize: 15 }}>
                            % Asistencia Perfecta
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={2}>
                      <Card className="h-100 border-secondary">
                        <Card.Body className="text-center">
                          <h1 className="display-6 text-secondary">
                            {indicadoresAsistencia.laborables}
                          </h1>
                          <p className="text-muted mb-0" style={{ fontSize: 15 }}>
                            Días laborables
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Card className="shadow border-0" style={{ borderRadius: 18, background: "#fff", minHeight: 220 }}>
                        <Card.Body>
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <TbReportAnalytics style={{ fontSize: 28, color: "#1976d2" }} />
                            <h5 className="fw-bold mb-0" style={{ color: "#1976d2" }}>
                              Asistencias diarias del mes
                            </h5>
                          </div>
                          <div style={{ minHeight: 180 }}>
                            <Line
                              data={indicadoresAsistencia.dailyAttendanceChart}
                              options={{
                                responsive: true,
                                plugins: {
                                  legend: { display: false },
                                  title: { display: false }
                                },
                                scales: {
                                  y: {
                                    title: { display: true, text: "N° de asistencias" },
                                    beginAtZero: true,
                                    ticks: { stepSize: 1, precision: 0 }
                                  },
                                  x: {
                                    title: { display: true, text: "Día del mes" },
                                    ticks: { autoSkip: false }
                                  }
                                }
                              }}
                            />
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* DASHBOARD CONTABLE - NUEVO */}
      { (usuario?.rol === "superAdmin" || usuario?.rol === "admin") && (
        <>
          <Row className="mb-4 mt-5">
            <Col>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <HiOutlineReceiptTax style={{ fontSize: 32, color: "#1a237e" }} />
                    <h2 className="fw-bold mb-0" style={{ letterSpacing: 1, color: "#1a237e" }}>
                      Gestión Contable y Balance
                    </h2>
                  </div>
                  <div className="text-muted" style={{ fontSize: 16, marginLeft: 4 }}>
                    Resumen de ingresos, egresos y utilidad del periodo actual
                  </div>
                </div>
                <Button 
                  href="/gestion-contable" 
                  variant="outline-primary" 
                  className="rounded-pill px-4"
                  style={{ fontWeight: 600 }}
                >
                  Ver Módulo Completo
                </Button>
              </div>
            </Col>
          </Row>

          {loadingContabilidad ? (
            <Row className="mb-4 g-4">
              {[1, 2, 3].map(i => (
                <Col key={i} md={4}>
                  <Card className="shadow border-0 h-100" style={{ borderRadius: 18 }}>
                    <Card.Body className="text-center py-4">
                      <div className="skeleton mb-2" style={{ width: 30, height: 30, margin: "0 auto" }}></div>
                      <div className="skeleton mb-2" style={{ width: "70%", height: 15, margin: "0 auto" }}></div>
                      <div className="skeleton" style={{ width: "90%", height: 35, margin: "0 auto" }}></div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : errorContabilidad ? (
            <Row className="mb-4">
              <Col>
                <Card className="text-center border-0 shadow-sm p-4" style={{ borderRadius: 18 }}>
                  <p className="text-muted mb-0">No se pudo cargar la información financiera. Asegúrese de haber configurado sus cuentas contables.</p>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row className="mb-4 g-4">
              <Col md={4}>
                <Card 
                  className="shadow border-0 h-100" 
                  style={{ 
                    borderRadius: 18, 
                    background: "linear-gradient(135deg, #e8f5e9 0%, #ffffff 100%)",
                    borderLeft: "6px solid #43a047"
                  }}
                >
                  <Card.Body className="py-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h6 className="fw-bold text-muted text-uppercase small">Ingresos Operativos</h6>
                        <h2 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                          S/ {indicadoresContables.pnl.ingresos.toLocaleString('es-PE', { minimumFractionDigits: 2 })}
                        </h2>
                      </div>
                      <div style={{ background: "rgba(67, 160, 71, 0.1)", padding: 10, borderRadius: 12 }}>
                        <BsGraphUp style={{ fontSize: 24, color: "#43a047" }} />
                      </div>
                    </div>
                    <div className="small text-muted">
                      Ventas netas y otros ingresos del periodo
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card 
                  className="shadow border-0 h-100" 
                  style={{ 
                    borderRadius: 18, 
                    background: "linear-gradient(135deg, #ffebee 0%, #ffffff 100%)",
                    borderLeft: "6px solid #e53935"
                  }}
                >
                  <Card.Body className="py-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h6 className="fw-bold text-muted text-uppercase small">Gastos y Egresos</h6>
                        <h2 className="fw-bold mb-0" style={{ color: "#c62828" }}>
                          S/ {indicadoresContables.pnl.gastos.toLocaleString('es-PE', { minimumFractionDigits: 2 })}
                        </h2>
                      </div>
                      <div style={{ background: "rgba(229, 57, 53, 0.1)", padding: 10, borderRadius: 12 }}>
                        <FaWallet style={{ fontSize: 24, color: "#e53935" }} />
                      </div>
                    </div>
                    <div className="small text-muted">
                      Costos operativos y gastos administrativos
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card 
                  className="shadow border-0 h-100" 
                  style={{ 
                    borderRadius: 18, 
                    background: "linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%)",
                    borderLeft: "6px solid #1e88e5"
                  }}
                >
                  <Card.Body className="py-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h6 className="fw-bold text-muted text-uppercase small">Utilidad Neta (Estimada)</h6>
                        <h2 className="fw-bold mb-0" style={{ color: "#1565c0" }}>
                          S/ {indicadoresContables.pnl.utilidad.toLocaleString('es-PE', { minimumFractionDigits: 2 })}
                        </h2>
                      </div>
                      <div style={{ background: "rgba(30, 136, 229, 0.1)", padding: 10, borderRadius: 12 }}>
                        <FaCalculator style={{ fontSize: 24, color: "#1e88e5" }} />
                      </div>
                    </div>
                    <div className="small text-muted">
                      Resultado antes de impuestos
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        </>
      )}

      {/* AGENTES DE INTELIGENCIA ARTIFICIAL */}
      <Row className="mb-4 mt-5">
        <Col>
          <div className="d-flex align-items-center gap-2 mb-2">
            <FaRobot style={{ fontSize: 32, color: "#8b4513" }} />
            <h2 className="fw-bold mb-0" style={{ letterSpacing: 1, color: "#8b4513" }}>
              Agentes de Inteligencia Artificial
            </h2>
          </div>
          <div className="text-muted" style={{ fontSize: 16, marginLeft: 4 }}>
            Potencia tu gestión con asistentes especializados
          </div>
        </Col>
      </Row>

      <Row className="mb-5 g-4">
        <Col md={6}>
          <Card 
            className="shadow border-0 h-100 overflow-hidden" 
            style={{ 
              borderRadius: 20, 
              background: "linear-gradient(135deg, #ffffff 0%, #fff9f0 100%)",
              borderLeft: "8px solid #8b4513"
            }}
          >
            <Card.Body className="p-4">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div style={{ background: "rgba(139, 69, 19, 0.1)", padding: 15, borderRadius: 15 }}>
                  <FaBrain style={{ fontSize: 32, color: "#8b4513" }} />
                </div>
                <Badge bg="warning" text="dark" className="px-3 py-2" style={{ borderRadius: 10 }}>Expert Agent</Badge>
              </div>
              <h3 className="fw-bold" style={{ color: "#3d1f0a" }}>Lexi - Experta Legal</h3>
              <p className="text-muted" style={{ fontSize: 15 }}>
                Especialista en análisis de reglamentos, normativas y procesamiento de documentos legales de RRHH.
              </p>
              <div className="d-flex gap-2 mt-4">
                <Button 
                  href="/documentos/procesador/lexi" 
                  variant="outline-primary" 
                  className="rounded-pill flex-grow-1"
                  style={{ borderColor: "#8b4513", color: "#8b4513", fontWeight: 600 }}
                >
                  Procesador
                </Button>
                <Button 
                  href="/documentos/procesador/chat-lexi" 
                  variant="primary" 
                  className="rounded-pill flex-grow-1"
                  style={{ background: "#8b4513", border: "none", fontWeight: 600 }}
                >
                  Chat con Lexi
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card 
            className="shadow border-0 h-100 overflow-hidden" 
            style={{ 
              borderRadius: 20, 
              background: "linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%)",
              borderLeft: "8px solid #1976d2"
            }}
          >
            <Card.Body className="p-4">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div style={{ background: "rgba(25, 118, 210, 0.1)", padding: 15, borderRadius: 15 }}>
                  <FaRocket style={{ fontSize: 32, color: "#1976d2" }} />
                </div>
                <Badge bg="info" className="px-3 py-2" style={{ borderRadius: 10 }}>Smart Recruiting</Badge>
              </div>
              <h3 className="fw-bold" style={{ color: "#0d47a1" }}>Hiro - Recruitment Pro</h3>
              <p className="text-muted" style={{ fontSize: 15 }}>
                Localiza los mejores candidatos con búsqueda semántica multimodal (CVs, Imágenes, DNI).
              </p>
              <div className="d-flex gap-2 mt-4">
                <Button 
                  href="/documentos/procesador/hiro" 
                  variant="outline-primary" 
                  className="rounded-pill flex-grow-1"
                  style={{ fontWeight: 600 }}
                >
                  Procesador CV
                </Button>
                <Button 
                  href="/documentos/procesador/chat-hiro" 
                  variant="primary" 
                  className="rounded-pill flex-grow-1"
                  style={{ background: "#1976d2", border: "none", fontWeight: 600 }}
                >
                  Chat con Hiro
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <footer className="text-center text-muted mt-5 mb-2" style={{ fontSize: 16 }}>
        <span>
          Mi Boleta Administrador &copy; {new Date().getFullYear()} &middot;
          Hecho con <span style={{ color: "#e25555" }}>♥</span>
        </span>
      </footer>
      </>
      )}
      <style jsx="true">{`
        .card {
          transition: box-shadow 0.2s;
        }
        .card:hover {
          box-shadow: 0 8px 32px 0 rgba(74, 158, 255, 0.15), 0 1.5px 8px 0 rgba(0,0,0,0.06);
        }
        .form-select:focus {
          border-color: #1976d2;
          box-shadow: 0 0 0 0.15rem rgba(25, 118, 210, 0.15);
        }
      `}</style>
    </Container>
  );
}
export default Home;